<script setup lang="ts">
import ButtonText from '@/shared/components/UI/Buttons/ButtonText.vue';
import IconDownload from '@/shared/components/UI/Icons/IconDownload.vue';
import { useTranslations } from '@/shared/composables/useTranslations';
import { posthogEvents } from '@/shared/constants/constants';

const { t } = useTranslations();

const {
  sku,
  loading = false,
  error = null
} = defineProps<{
  sku: string;
  loading?: boolean;
  error?: string | null;
}>();

const emit = defineEmits<{
  retry: [];
}>();

const handleRetry = () => {
  window.posthog?.capture(posthogEvents.PATTERN_DOWNLOAD_RETRY, {
    pattern_sku: sku
  });
  emit('retry');
};
</script>

<template>
  <p class="text-sm text-black">
    {{ t('patterns.download.success_content.sentence2') }}
  </p>

  <p v-if="error" class="text-xs font-semibold text-error" role="alert">
    {{ error }}
  </p>

  <ButtonText
    theme="primary"
    size="lg"
    full-width
    class="justify-center"
    :label="t('patterns.download.download_pattern_here')"
    :loading="loading"
    @click="handleRetry"
  >
    <template #icon>
      <IconDownload class="size-5 shrink-0" aria-hidden="true" />
    </template>
  </ButtonText>
</template>
